import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from '../defaultProps'

export const Volume = createIcon({
  displayName: 'Volume',
  path: (
    <path
      d='M7.16767 2.2203L4.202 4.99999H0.8C0.358 4.99999 0 5.33562 0 5.74999V10.25C0 10.6641 0.358 11 0.8 11H4.202L7.16767 13.7797C7.66867 14.2494 8.53333 13.9194 8.53333 13.2494V2.75062C8.53333 2.07999 7.668 1.75124 7.16767 2.2203ZM16 7.99999C16 6.01468 14.9313 4.18937 13.141 3.11749C12.768 2.89437 12.2733 2.99812 12.037 3.35062C11.8007 3.70312 11.911 4.16968 12.284 4.39312C13.609 5.18655 14.4 6.53468 14.4 7.99999C14.4 9.4653 13.609 10.8134 12.284 11.6069C11.911 11.83 11.8007 12.2966 12.037 12.6494C12.254 12.9731 12.741 13.1225 13.141 12.8825C14.9313 11.8106 16 9.9853 16 7.99999ZM11.2743 5.5978C10.8883 5.39999 10.4013 5.5303 10.1873 5.89312C9.97433 6.25593 10.1153 6.71187 10.5023 6.91218C10.9327 7.13374 11.2 7.55093 11.2 7.99999C11.2 8.44937 10.9327 8.86624 10.5027 9.0878C10.1157 9.28812 9.97467 9.74406 10.1877 10.1069C10.402 10.4712 10.8893 10.6006 11.2747 10.4022C12.2157 9.91624 12.8003 8.99593 12.8003 7.99968C12.8003 7.00343 12.2157 6.08343 11.2743 5.5978Z'
      fill='#AC0AE8'
    />
  ),
  viewBox: '0 0 16 16',
  defaultProps: {
    ...defaultProps,
    width: 4,
    height: 4
  }
})

export const Mute = createIcon({
  displayName: 'Mute',
  path: [
    <g clipPath='url(#clip0)'>
      <path
        d='M6.71969 2.2203L3.93937 4.99999H0.75C0.335625 4.99999 0 5.33562 0 5.74999V10.25C0 10.6641 0.335625 11 0.75 11H3.93937L6.71969 13.7797C7.18937 14.2494 8 13.9194 8 13.2494V2.75062C8 2.07999 7.18875 1.75124 6.71969 2.2203ZM14.4263 7.99999L15.8525 6.57374C16.0494 6.37687 16.0494 6.05749 15.8525 5.86062L15.1394 5.14749C14.9425 4.95062 14.6231 4.95062 14.4263 5.14749L13 6.57374L11.5737 5.14749C11.3769 4.95062 11.0575 4.95062 10.8606 5.14749L10.1475 5.86062C9.95063 6.05749 9.95063 6.37687 10.1475 6.57374L11.5737 7.99999L10.1478 9.42593C9.95094 9.62281 9.95094 9.94218 10.1478 10.1391L10.8609 10.8522C11.0578 11.0491 11.3772 11.0491 11.5741 10.8522L13 9.42624L14.4263 10.8525C14.6231 11.0494 14.9425 11.0494 15.1394 10.8525L15.8525 10.1394C16.0494 9.94249 16.0494 9.62312 15.8525 9.42624L14.4263 7.99999Z'
        fill='#AC0AE8'
      />
    </g>,
    <defs>
      <clipPath id='clip0'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  ],
  viewBox: '0 0 16 16',
  defaultProps: {
    ...defaultProps,
    width: 4,
    height: 4
  }
})
